export default __webpack_public_path__ + "static/media/LOGO_SALVADOR.6857f01b.jpg";